import { createSlice } from "@reduxjs/toolkit";
import { createAsyncThunk } from "@reduxjs/toolkit";

import { APP_URL } from "../request/api";
import { request } from "../request/request";

const initialState = {
    columns: [],
    data: [],
    meta: {},
    links: {},
    loadingStatus: "idle",
    error: null
}

export const fetchViolations = createAsyncThunk(
    'violations/fetchViolations',
    async ({token, id,   page, params}, {rejectWithValue}) => {
        try {
            const customHeaders = {
                Authorization: `Bearer ${token}`
            }

            const response = await request(
                `${APP_URL}/surveys/${id}/violations`,
                'GET',
                null,
                customHeaders
            )

            return response;
        } catch (error) {
            rejectWithValue(error);
        }
    }
)

const violationsSlice = createSlice({
    name: "violations",
    initialState: initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(fetchViolations.pending, (state) => {
                state.loadingStatus = "loading";
                state.columns = null;
                state.data = null;
                state.error = null;
            })
            .addCase(fetchViolations.fulfilled, (state, action) => {
                state.loadingStatus = "idle";
                state.columns = action.payload.columns;
                state.data = action.payload.data;
                state.error = null;
            })
            .addCase(fetchViolations.rejected, (state, action) => {
                state.loadingStatus = "rejected";
                state.columns = null;
                state.data = null;
                state.error = action.payload;
            })
    }
})

export default violationsSlice.reducer;